import type { FC } from 'react'

import { LinearLoader } from './LinearLoader'

export interface ITextLoaderProps {
  width?: string | number
  height?: number
  inverted?: boolean
}

export const TextLoader: FC<ITextLoaderProps> = ({
  width = '100%',
  height = 14,
  inverted = false,
}) => (
  <LinearLoader
    variant='skeleton'
    width={width}
    height={height}
    borderRadius={4}
    inverted={inverted}
  />
)

TextLoader.displayName = 'TextLoader'
